<template>
  <div>
    <v-hover
      v-for="(item, index) in processData.records"
      :key="index"
      v-slot="{ hover }"
    >
      <v-sheet
        :color="hover ? 'grey lighten-4': 'white'"
        class="px-4 py-3"
        style="cursor: pointer; margin-bottom: 1px;"
        @click="$emit('itemClick', item)"
      >
        <h4
          class="text-truncate"
          :class="{ 'text-decoration-line-through': item.inflowStatusCode === 'V' }"
        >
          {{ item.senderCode?item.senderCode:item.caseId }} {{ item.subject }}
        </h4>
        <div class="d-flex align-center">
          <div class="mr-4 text-body-2 grey--text text--darken-1 text-truncate">
            <span
              v-if="item.subjectObser"
            >{{ $t('eDocInternal.subjectObser') }}：{{ item.subjectObser }} <br></span>
            <span
              v-if="item.receiveCode"
              class="mr-4"
            >{{ $t('eDocInternal.receiveCode') }}：{{ item.receiveCode }}</span>
            <span v-if="item.chinSenderEntityName || item.portSenderEntityName">{{ $t('eDocInternal.sendDocEntity') }}：{{ $chPtObjData('chinSenderEntityName', item) }}</span>
          </div>
          <!-- <div>
            <v-chip
              color="red"
              outlined
              small
            >
              緊急
            </v-chip>
          </div> -->
        </div>
        <div class="d-flex align-end text-body-2">
          <div>
            <span
              v-if="item.replyDeadline"
              class="mr-4 text-no-wrap"
            >
              <v-icon color="red lighten-3">{{ mdiClockOutline }}</v-icon> {{ $t('eDocInternal.expectedReplyDate') }}: {{ momentWithHyphen(item.replyDeadline).format('YYYY-MM-DD') }}
            </span>
            <div>
              <v-chip
                v-if="item.urgentLevelId === 2"
                class="mr-2 mt-1"
                outlined
                small
                color="red"
              >
                {{ $chPtObjData('chinUrgentLevelName', item) }}
              </v-chip>
              <v-tooltip
                top
                color="black"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    v-if="$config.isShowEncrypted && item.securityLevelId && item.securityLevelId > 1"
                    small
                    outlined
                    :color="item.securityLevelId > 2 ? 'purple' : 'info'"
                    class="mr-2 mt-1"
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ $chPtObjData('chinSecurityLevelName', item) }}
                  </v-chip>
                </template>
                <span>{{ $chPtObjData('chinSecurityLevelName', item) }}</span>
              </v-tooltip>
            </div>
          </div>
          <!-- <span class="mr-4">
            {{ $chPtObjData('chinSenderName', item) }}
          </span> -->
          <!-- <v-icon
            color="success"
            class="mr-1"
          >
            {{ mdiInformationOutline }}
          </v-icon>
          <span class="success--text">已有建議內容</span> -->
          <v-spacer />
          <span class="grey--text text-caption text-no-wrap">{{ momentWithHyphen(item.modifiedTime).format('YYYY-MM-DD HH:mm') }}</span>
        </div>
      </v-sheet>
    </v-hover>

    <template v-if="processData.records && processData.records.length === 0">
      <v-sheet>
        <div class="px-4 py-3">
          {{ $t('PublicServant.NoData') }}
        </div>
      </v-sheet>
    </template>

    <div>
      <v-pagination
        v-if="processData"
        v-model="pageNum"
        :length="processData.pages"
        circle
        @input="handlePageChange"
      />
    </div>
  </div>
</template>

<script>

import { momentWithHyphen } from '@/utils/datetimeUtil'
import { docFlowMethod } from '@/mixins/docFlowMethod'
import { mdiInformationOutline, mdiClockOutline } from '@mdi/js'
import { DOC_FLOW_STATUS } from '@/constant/constant'
// import { docFlowModule } from '@/store/moduleName'

export default {
  mixins: [docFlowMethod],
  props: {
    processData: {
      type: Object,
      default: null
    }
  },
  data: () => {
    return {
      mdiInformationOutline: mdiInformationOutline,
      mdiClockOutline: mdiClockOutline,
      status: [DOC_FLOW_STATUS.PROCESSED, DOC_FLOW_STATUS.CLOSED, DOC_FLOW_STATUS.REDIRECTED] // for docFlowMethod
      // dfType: DOC_FLOW_TYPE.DOC_FLOW // for docFlowMethod
    }
  },
  computed: {
    /* onlyShowPrefilled: {
      get () {
        return this.$store.state[docFlowModule].onlyShowPrefilled
      }
    },
    filterText: {
      get () {
        return this.$store.state[docFlowModule].filterText
      }
    } */
  },
  methods: {
    handlePageChange (value) {
      this.pageNum = value
      this.getProcessList(false, this.filterText, this.status)
    },
    momentWithHyphen
  }
}
</script>
